import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    mainContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    smMargin: {
      margin: '2px',
    },
    actionDiv: {
      textAlign: 'center',
    }
}));